import * as React from 'react'
import { Helmet } from 'react-helmet'
import { useStaticQuery, graphql } from 'gatsby'
import { Script } from "gatsby"
function Seo({ description, title }) {
  const queryData = useStaticQuery(graphql`
    {
      site {
        siteMetadata {
          title
          description
        }
      }
    }
  `)

  const metaTitle = title
    ? ` ${queryData.site?.siteMetadata?.title} | ${title}`
    : queryData.site?.siteMetadata?.title
  const metaDescription =
    description || queryData.site?.siteMetadata?.description

  return (
    <Helmet>
      <title>{metaTitle}</title>
      <meta name="viewport" content="width=device-width, initial-scale=1.0" />
      <meta name="description" content={metaDescription} />
      <meta property="og:image" content='https://i.ibb.co/dr8XvDm/Social-Sharing-image-preview-2.png' />
      <script id="CookieConsent" src="https://policy.app.cookieinformation.com/uc.js"
    data-culture="EN" type="text/javascript"></script>
    <script async src="https://www.googletagmanager.com/gtag/js?id=G-JLZYZLJMVT"></script>

    <Script id="gtag-config">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag() {
          dataLayer.push(arguments);
        }
        gtag('consent', 'default', {
          ad_storage: 'denied',
          analytics_storage: 'denied',
          wait_for_update: 1500,
        });
        gtag('set', 'ads_data_redaction', true);
      `}
  </Script>
  <Script id="gtag-google-analytics">
      {`
        window.dataLayer = window.dataLayer || [];
        function gtag(){dataLayer.push(arguments);}
        gtag('js', new Date());
        ​
        gtag('config', 'G-JLZYZLJMVT');
      `}
  </Script>
    </Helmet>
  )
}
export default Seo